import { render } from "./editPlayerDocumentDialog.vue?vue&type=template&id=0f9c9eb0"
import script from "./editPlayerDocumentDialog.vue?vue&type=script&lang=js"
export * from "./editPlayerDocumentDialog.vue?vue&type=script&lang=js"

import "./editPlayerDocumentDialog.vue?vue&type=style&index=0&id=0f9c9eb0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__